
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M20.876 19.484l-4.268-4.268a.417.417 0 00-.3-.123h-.464a7.292 7.292 0 001.779-4.781A7.311 7.311 0 0010.312 3 7.311 7.311 0 003 10.312a7.311 7.311 0 007.312 7.312 7.292 7.292 0 004.781-1.779v.464a.432.432 0 00.123.3l4.268 4.267a.422.422 0 00.6 0l.794-.794a.422.422 0 00-.002-.598zm-10.564-3.547a5.623 5.623 0 01-5.625-5.625 5.623 5.623 0 015.625-5.625 5.623 5.623 0 015.625 5.625 5.623 5.623 0 01-5.625 5.625z"
  })));
}

export { SvgMagnifier as default };
//# sourceMappingURL=magnifier.svg.js.map
